import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import '@/styles/index.scss'
import App from './App';
import zhCN from 'antd/locale/zh_CN';
import {ConfigProvider} from 'antd'

ReactDOM.render(
  
    <ConfigProvider locale={zhCN}>
    <App />
  </ConfigProvider>
  ,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
